import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import CitationContent from "../components/CitationContent";

const EbookPreview = () => {
  const [html, setHtml] = useState("");
  const [bookName, setBookName] = useState("Preview");

  useEffect(() => {
    const storedHtml = sessionStorage.getItem("ebookPreviewHtml");
    const storedBook = sessionStorage.getItem("ebookPreviewBook");

    setHtml(storedHtml || "<p>No preview data</p>");
    setBookName(storedBook || "Preview");
  }, []);

  // fake node shape to reuse your component
  const previewNode = {
    id: "preview-node",
    verified_content: html,
  };

  return (
    <div
      style={{
        background: "#f8fafc",
        minHeight: "100vh",
        padding: "30px",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "#fff",
          padding: "24px",
          borderRadius: "8px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
        }}
      >
        <h2 style={{ marginBottom: 20 }}>{bookName} — Preview</h2>

        <CitationContent node={previewNode} />
      </div>
    </div>
  );
};

export default EbookPreview;
